import React, {useState} from 'react';
import Link from '../../../components/link';
import classnames from 'classnames';
import appLinks from '../../../utils/config/appLinks';
import webUtils from '../../../utils/webUtils';
import useReactRouter from 'use-react-router';
import './MobileConsumerMenus.css';
import {useHistory} from 'react-router';
import {Trans, useTranslation} from 'react-i18next';
import GoogleSearch from '../googlesearch';
import useWindowWidth from '../../hooks/useWindowWidth';
import headerUtils from '../../../utils/headerUtils';
import _isEmpty from 'lodash/isEmpty';

let MENU = '';
export default function MobileConsumerMenus({setPopupMenu}) {
  const {i18n} = useTranslation();
  const [menu, setMenu] = useState(MENU);
  const [showAiPhotoEditingTool, setAiPhotoEditingTool] = useState(false);
  const [showGenAi, setShowGenAi] = useState(false);
  const {location} = useReactRouter();
  const history = useHistory();
  const language =
    i18n.language === 'en' || !i18n.language
      ? ''
      : `/${i18n.language.replace('_', '-').toLowerCase()}`;

  const isActive = path => location.pathname === path;
  const isApps = () => menu === 'apps';
  const switchMenu = (input = 'apps') => {
    const r = menu === input ? '' : input;
    MENU = r;
    setMenu(r);
  };
  const consumerApps = headerUtils.consumerApps;
  const aiphotoeditingtool = headerUtils.aiphotoeditingtool.filter(r => r);
  const genai = headerUtils.genai;
  const width = useWindowWidth();
  const renderAppLinks = () => {
    const notShowYce = webUtils.isAndroid() && width <= 600;
    return consumerApps
      .filter(s => !(s === 'yce' && notShowYce))
      .map((m, i) => (
        <div
          key={'menu-' + i}
          className={classnames({
            'pf-header-mobile-consumer-menus__subitem': true,
            'pf-header-mobile-consumer-menus__subitem--active': isActive(
              appLinks[m].link
            ),
          })}
        >
          <Link to={appLinks[m].link} onClick={() => setPopupMenu(false)}>
            {i18n.t(appLinks[m].i18nKey, appLinks[m].text)}
          </Link>
        </div>
      ));
  };
  const renderLinks = menu => {
    return (
      !_isEmpty(menu) &&
      menu.map((m, i) => (
        <div
          key={'menu-' + i}
          className={classnames({
            'pf-header-mobile-consumer-menus__subitem': true,
          })}
        >
          <Link
            isYce={m.isYce}
            yceKeyword={m.yceKeyword}
            onClick={() => setPopupMenu(false)}
            hash={m.hash}
            to={m.link}
          >
            {m.text}
          </Link>
        </div>
      ))
    );
  };

  function renderArrowIcon(isUp) {
    const iconClass = isUp
      ? 'fa fa-caret-up pf-header-mobile-consumer-menus__icon'
      : 'fa fa-caret-down pf-header-mobile-consumer-menus__icon';

    return <i className={iconClass} />;
  }

  return (
    <div className="pf-header-mobile-consumer-menus">
      <div
        className={classnames({
          'pf-header-mobile-consumer-menus__item': true,
        })}
      >
        <GoogleSearch is2b={false} />
      </div>
      <div
        className={classnames({
          'pf-header-mobile-consumer-menus__item': true,
          'pf-header-mobile-consumer-menus__item--opened': isApps(),
        })}
        onClick={() => switchMenu('apps')}
      >
        <Trans i18nKey="consumer:u.c.applinks.home">Our Apps</Trans>{' '}
        {renderArrowIcon(isApps())}
      </div>
      {isApps() && renderAppLinks()}

      <div
        className={classnames({
          'pf-header-mobile-consumer-menus__item': true,
          'pf-header-mobile-consumer-menus__item--opened': showAiPhotoEditingTool,
        })}
        onClick={() => setAiPhotoEditingTool(!showAiPhotoEditingTool)}
      >
        <Trans i18nKey="consumer:u.c.leftmenu.ai.photo.editing.tool">
          AI Photo Editing Tool
        </Trans>{' '}
        {renderArrowIcon(showAiPhotoEditingTool)}
      </div>
      {showAiPhotoEditingTool && renderLinks(aiphotoeditingtool)}

      <div
        className={classnames({
          'pf-header-mobile-consumer-menus__item': true,
          'pf-header-mobile-consumer-menus__item--opened': showGenAi,
        })}
        onClick={() => setShowGenAi(!showGenAi)}
      >
        <Trans i18nKey="consumer:u.c.leftmenu.generative.ai">
          Generative AI
        </Trans>{' '}
        {renderArrowIcon(showGenAi)}
      </div>
      {showGenAi && renderLinks(genai)}

      <div
        className={classnames({
          'pf-header-mobile-consumer-menus__item': true,
        })}
        onClick={() => {
          history.push(`${language}/consumer/blog`);
          setPopupMenu(false);
        }}
      >
        <div
          className={classnames({
            'pf-subheader-4-consumer__left-menu--active':
              location.pathname.indexOf('/consumer/blog') !== -1,
            'pf-content-popupmenu1 pf-content-popupmenu1--white': true,
          })}
          style={
            location.pathname.indexOf('/consumer/blog') !== -1
              ? {}
              : {color: '#ffffff'}
          }
        >
          <Trans i18nKey="consumer:u.c.blog">Blog</Trans>
        </div>
      </div>

      <div
        className={classnames({
          'pf-header-mobile-consumer-menus__item': true,
        })}
        onClick={() => {
          window.location.href = 'https://ir.perfectcorp.com/';
        }}
      >
        <div
          className={classnames({
            'pf-content-popupmenu1 pf-content-popupmenu1--white': true,
          })}
          style={{color: '#ffffff'}}
        >
          <Trans i18nKey="business:c.l.s.rightmenu.investors">Investors</Trans>
        </div>
      </div>
    </div>
  );
}
